import { UserManager, User } from 'oidc-client-ts';
import { getAuthSettings } from '../utilities/authConfigHelper';

const authSettings = getAuthSettings();
const userManager = new UserManager(authSettings);

export class AuthService {
    public async login(): Promise<void> {
        await userManager.signinRedirect();
    }

    public async handleCallback(): Promise<User | null> {
        try {
            const user = await userManager.signinRedirectCallback();
            return user;
        } catch (error) {
            console.error('Error handling callback', error);
            return null;
        }
    }

    public async logout(): Promise<void> {
        await userManager.signoutRedirect();
    }

    public async getUser(): Promise<User | null> {
        return await userManager.getUser();
    }

    public async isAuthenticated(): Promise<boolean> {
        const user = await this.getUser();
        return user != null && !user.expired;
    }

    public async checkAuthentication(): Promise<void> {
        const user = await this.getUser();
        if (!user || user.expired) {
            await this.login();
        }
    }

    public getUserManager(): UserManager {
        return userManager;
    }

    public async getAccessToken(): Promise<string | null> {
        const user = await this.getUser();
        if (user && !user.expired) {
            return user.access_token;
        }
        return null;
    }
}

export const authService = new AuthService();